import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import UserLayout from './components/Layout/UserLayout';
import Home from './pages/Home';
import { Toaster } from "sonner";
import Login from './pages/Login';
import Register from './pages/Register';
import Profile from './pages/Profile';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import About from './pages/About';
import Return from './pages/Return';
import Terms from './pages/Terms';
import Contact from './pages/Contact';
import Shipping from './pages/Shipping';
import ReturnPolicy from './pages/ReturnPolicy';
import CancellationAndReturnPolicy from './pages/CancellationAndReturnPolicy';
import PrivacyPolicy from './pages/Privacypolicy';
import ProductDetails from './components/Products/ProductDetails';
import CollectionPage from './pages/CollectionPage';
import BogoPage from './pages/BogoPage';
import Checkout from './components/Cart/Checkout';
import OrderConfirmationPage from './pages/OrderConfirmationPage';
import CancellationModal from './pages/CancellationModal';
import OrderDetailsPage from './pages/OrderDetailsPage';
import MyOrdersPage from './pages/MyOrdersPage';
import AdminLayout from './components/Admin/AdminLayout';
import AdminHomePage from './pages/AdminHome';
import UserManagement from './pages/UserManagement';
import DeleteAccountPage from './pages/DeleteAccountPage';
import RecoverAccountPage from './pages/Recoveraccountpage';
import ProductManagement from './components/Admin/ProductManagement';
import EditProductPage from './components/Admin/EditProductPage';
import OrderManagement from './components/Admin/OrderManagement';
import AdminReturnsPage from './components/Admin/AdminReturnsPage';
import AdminMessages from "./components/Admin/AdminMessages.jsx";
import OfferManagement from "./components/Admin/OfferManagement";



import FestivalLayer from './festival/FestivalLayer';

// import Snowfall from "react-snowfall";

import {Provider} from "react-redux";
import store from "../redux/store";
import ProtectedRoute from './components/Common/ProtectedRoute';
import ScrollToTop from './components/Common/ScrollToTop';


const App = () => {
  return (
    <Provider store={store}>
    <BrowserRouter>

      <FestivalLayer />
      
      {/* Scroll to top on route change */}
      <ScrollToTop />

 {/* <div className="snow-global-wind"> */}
  
  {/* LAYER 1 – background haze (tiny, blurred snow) */}
  {/* <Snowfall
    snowflakeCount={120}
    radius={[0.4, 1.0]}
    speed={[0.15, 0.5]}
    wind={[-0.3, 0.3]}
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      pointerEvents: "none",
      opacity: 0.22,
      filter: "blur(2px)",
      zIndex: 1
    }}
  /> */}

  {/* LAYER 2 – mid-ground snow (usual flakes) */}
  {/* <Snowfall
    snowflakeCount={70}
    radius={[1.0, 2.0]}
    speed={[0.4, 1.1]}
    wind={[-1.2, 1.2]}
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      pointerEvents: "none",
      opacity: 0.6,
      zIndex: 2
    }}
  /> */}

  {/* LAYER 3 – occasional bigger flakes (foreground sparkle) */}
   {/* <Snowfall
    snowflakeCount={30}
    radius={[2.2, 4.0]}
    speed={[0.5, 1.5]}
    wind={[-2, 2]}
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      pointerEvents: "none",
      opacity: 0.85,
      filter: "drop-shadow(0 0 4px rgba(255,255,255,0.8))",
      zIndex: 3
    }}
  />
</div>  */}

    <Toaster position="top-right" reverseOrder={false} />
    
    <Routes>
    <Route path="/" element={<UserLayout />}>

    {/* User Layout */}
    <Route index element={<Home />} />
    <Route path="login" element={<Login />} />
    <Route path="register" element={<Register />} />
    <Route path="/forgot-password" element={<ForgotPassword />} />
    <Route path="/reset-password/:token" element={<ResetPassword />} />
    <Route path="profile" element={<Profile />} />
    <Route path="product/:id" element={<ProductDetails />} />
    <Route path="collections/:collection" element={<CollectionPage />} />
    <Route path="bogo" element={<BogoPage />} />
    <Route path="checkout" element={<Checkout />} />
    <Route path="order-confirmation" element={<OrderConfirmationPage />} />
    <Route path="CancellationModal" element={<CancellationModal />} />  
    <Route path="order/:id" element={<OrderDetailsPage />} />
    <Route path="order/:orderId/my-orders" element={<MyOrdersPage />} />
    <Route path="my-orders" element={<MyOrdersPage />} />
    <Route path="about" element={<About />} />
    <Route path="return" element={<Return />} />
    <Route path="returnpolicy" element={<ReturnPolicy />} />
    <Route path="cancellationandreturnpolicy" element={<CancellationAndReturnPolicy />} />
    <Route path="privacypolicy" element={<PrivacyPolicy />} />
    <Route path="terms" element={<Terms />} />
    <Route path="contact" element={<Contact />} />
    <Route path="shipping" element={<Shipping />} />
    <Route path="/DeleteAccountPage" element={<DeleteAccountPage />} />
    <Route path="/recover-account" element={<RecoverAccountPage />} />
    </Route>
    
    <Route path="/admin" element={
      <ProtectedRoute role="admin">
      <AdminLayout />
      </ProtectedRoute>} >
    
    {/* Admin Layout */}
    <Route index element={<AdminHomePage />} />
    <Route path="users" element={<UserManagement />} />
    <Route path="products" element={<ProductManagement />} />
    <Route path="products/:id/edit" element={<EditProductPage />} /> 
    <Route path="orders" element={<OrderManagement />} />
    <Route path="offers" element={<OfferManagement />} />
      

    <Route path="/admin/returns" element={<AdminReturnsPage />} />

      <Route path="/admin/messages" element={<AdminMessages />} />


      
    </Route>
    </Routes>
    
    </BrowserRouter>
    </Provider>
  )
}

export default App;
